module.exports = {
  parse: function parse() {
    return this.createSingleNodeList(this.Identifier());
  }
};